// builderMobileGate — staging port of Dev's F1/F2 desktop-only gate
// (fix-capture-stg-builder-390-squeezed-desktop-v3).
//
// The full builder canvas was rendering at phone widths on staging instead of
// the desktop-only interstitial Dev already shows: Wheel-Name/Subtitle inputs
// collapse to slivers and the right tool-rail runs off the viewport. Gordon's
// decision 2026-09-08: staging shows the SAME desktop-only gate as Dev, not a
// responsive builder. Staging has no responsive-tablet builder to carve an
// exception for (unlike Dev's QA-1279 flag), so this ports only the original,
// single-arg cut — the same 768 floor Gallery/View-Wheel already gate on via
// useScreenSize().isMobile.
export const BUILDER_MOBILE_FLOOR = 768;

// Pure + window-free so it is unit-testable.
export function shouldGateBuilder(width) {
  return (Number(width) || 0) <= BUILDER_MOBILE_FLOOR;
}
